module.exports = __webpack_public_path__ + "img/credit-card.4aac3aa1.svg";